import { render, staticRenderFns } from "./registerDetail.vue?vue&type=template&id=d5b83b40&scoped=true&"
import script from "./registerDetail.vue?vue&type=script&lang=js&"
export * from "./registerDetail.vue?vue&type=script&lang=js&"
import style0 from "./registerDetail.vue?vue&type=style&index=0&id=d5b83b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b83b40",
  null
  
)

export default component.exports